class STLProductCarousel extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.swiper = null
    this.nextBtn = this.querySelector('.swiper-nav-btn-next')
    this.prevBtn = this.querySelector('.swiper-nav-btn-prev')
    this.init()
  }

  disconnectedCallback() {
    this.swiper?.destroy(true, true)
  }

  init() {
    this.swiper = new Swiper(this.querySelector('.stl-product-card-carousel'), {
      slidesPerView: 1.6,
      spaceBetween: 5,
      loop: true,
      navigation: {
        nextEl: this.nextBtn,
        prevEl: this.prevBtn,
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 20,
          loop: false,
          rewind: true,
        },
      },
    })
  }
}

customElements.define('stl-product-carousel', STLProductCarousel)
